export default "__VITE_ASSET__Dp35QA8F__"